import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import ChatWindow from '../ChatWindow';
import ErrorBoundary from '../ErrorBoundary';
import { loadChatHistory } from '../../utils/chatStorage';
import { isINESAccount, isINESBranch } from '../../../utils/inesValidator';
import './ChatbotWidget.scss';

const ChatbotWidget = ({
  isOpen,
  messages,
  isTyping,
  locale,
  currentStep,
  currentSection,
  currentQuestion,
  confirmationTimer,
  contactForm,
  account,
  branch,
  userGroups,
  isContactSubmitting,
  contactError,
  toggle,
  navigate,
  goBack,
  selectMenuOption,
  selectQuestion,
  submitContact,
  startChat,
  goToMenu,
  goToContact,
  loadHistory,
  clearHistory,
}) => {
  const isINESAccountCheck = account ? isINESAccount(account) : false;
  const isINESBranchCheck = branch?.name ? isINESBranch(branch.name) : false;
  const isINES = isINESAccountCheck || isINESBranchCheck;

  useEffect(() => {
    try {
      const stored = loadChatHistory();
      if (stored) {
        // Validar que el estado cargado tenga la estructura correcta
        if (!Array.isArray(stored.navigationStack)) {
          console.warn(
            '⚠️ Estado del chatbot corrupto en localStorage, limpiando...',
          );
          clearHistory();
          return;
        }
        loadHistory(stored);
      }
    } catch (error) {
      console.error('Error cargando historial del chatbot:', error);
      clearHistory();
    }
  }, [loadHistory, clearHistory]);

  return (
    <div className={`chatbot-widget ${isOpen ? 'chatbot-widget--open' : ''}`}>
      {isOpen ? (
        <ErrorBoundary onReset={() => clearHistory()}>
          <ChatWindow
            messages={messages}
            isTyping={isTyping}
            locale={locale}
            currentStep={currentStep}
            currentSection={currentSection}
            currentQuestion={currentQuestion}
            confirmationTimer={confirmationTimer}
            contactForm={contactForm}
            account={account}
            branch={branch}
            userGroups={userGroups}
            isContactSubmitting={isContactSubmitting}
            contactError={contactError}
            onClose={() => toggle(false)}
            onNavigate={navigate}
            onGoBack={goBack}
            onSelectMenuOption={selectMenuOption}
            onSelectQuestion={selectQuestion}
            onSubmitContact={submitContact}
            onStartChat={startChat}
            onGoToMenu={goToMenu}
            onGoToContact={goToContact}
          />
        </ErrorBoundary>
      ) : (
        <div className="chatbot-toggle-wrapper">
          <button
            className={`chatbot-toggle-btn ${
              isINES ? 'chatbot-toggle-btn--ines' : ''
            }`}
            onClick={() => toggle(true)}
            aria-label={I18n.t('chatbot.open')}
          >
            <span className="material-symbols-rounded">smart_toy</span>
          </button>
          <div className="chatbot-tooltip">{I18n.t('chatbot.tooltip')}</div>
        </div>
      )}
    </div>
  );
};

ChatbotWidget.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  messages: PropTypes.array.isRequired,
  isTyping: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  currentStep: PropTypes.string.isRequired,
  currentSection: PropTypes.string,
  currentQuestion: PropTypes.string,
  confirmationTimer: PropTypes.number,
  contactForm: PropTypes.object,
  account: PropTypes.object,
  branch: PropTypes.object,
  userGroups: PropTypes.array,
  isContactSubmitting: PropTypes.bool,
  contactError: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  selectMenuOption: PropTypes.func.isRequired,
  selectQuestion: PropTypes.func.isRequired,
  submitContact: PropTypes.func.isRequired,
  startChat: PropTypes.func.isRequired,
  goToMenu: PropTypes.func.isRequired,
  goToContact: PropTypes.func.isRequired,
  loadHistory: PropTypes.func.isRequired,
  clearHistory: PropTypes.func.isRequired,
};

export default ChatbotWidget;
